const messages = {
    buttons: {
        productBrochures: "Découvrir",
    },
    index: {
        title: "INFORMATION PRODUIT",
        description: "Téléchargez ici les dernières brochures et flyers de nos pneus Bridgestone et Firestone.",
        categories: {
            productBrochures: {
                title: "Brochures produit",
                description: "Brochures des gammes de pneus Bridgestone et Firestone",
            },
            bDrive: {
                title: "Images de produits",
                description: "Vous trouverez les images actuelles à télécharger sur notre portail B-DRIVE.",
            },
        
          kickback: {
            description: "Les entreprises participantes reçoivent des crédits sous forme de remises basées sur les chiffres de ventes transmis.",
          },}
    }
};

export default {
    messages,
};

